import { CheckCircle, XCircle } from 'lucide-react';

const AVANT = [
  { text: 'Paperasse infinie', desc: " : feuilles d'inscription, tableaux Excel, cahiers" },
  { text: 'Erreurs de calcul', desc: ' fréquentes dans les tableaux de compétition' },
  { text: 'Paiements en liquide', desc: ' difficiles à tracer et justifier' },
  { text: 'Communication chaotique', desc: ' : appels, SMS, groupes WhatsApp' },
  { text: 'Plusieurs heures de travail', desc: " par concours pour l'organisateur" },
];

const APRES = [
  { text: 'Inscriptions en ligne', desc: ' automatisées 24/7, zéro paperasse' },
  { text: 'Podium & résultats publics', desc: ' en un clic, partageables en un lien' },
  { text: 'Paiements sécurisés', desc: ' via Stripe, avec suivi comptable et reçus automatiques' },
  { text: 'Notifications auto', desc: ' : confirmations, alertes et suivi par email' },
  { text: 'Quelques minutes par concours', desc: ', le reste est automatisé' },
];

export default function ProblemSolution() {
  return (
    <section id='probleme' className='px-6 py-32 bg-slate-50 dark:bg-gray-950'>
      <div className='max-w-7xl mx-auto'>
        <div className='text-center mb-16'>
          <span className='text-blue-600 font-bold text-sm uppercase tracking-wider'>Le problème</span>
          <h2 className='text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mt-4 mb-6'>
            Organiser un concours, c'était un <span className='text-red-500'>cauchemar</span>
          </h2>
          <p className='text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto'>
            Avant BoulesConnect, beaucoup d'organisateurs de pétanque, de jeu provençal et de boule lyonnaise perdaient
            des heures en tâches répétitives et erreurs manuelles.
          </p>
        </div>

        <div className='grid md:grid-cols-2 gap-8'>
          {/* AVANT */}
          <div className='bg-white dark:bg-slate-900 rounded-3xl p-8 border-2 border-red-100 dark:border-red-900/40 relative overflow-hidden'>
            <div className='absolute top-4 right-4 bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-400 px-4 py-1 rounded-full text-xs font-bold'>
              AVANT
            </div>
            <h3 className='text-2xl font-bold text-slate-900 dark:text-white mb-6 mt-8'>La galère manuelle</h3>
            <ul className='space-y-4'>
              {AVANT.map(item => (
                <li key={item.text} className='flex items-start gap-3'>
                  <XCircle className='w-5 h-5 text-red-500 mt-1 flex-shrink-0' />
                  <span className='text-slate-600 dark:text-slate-400'>
                    <strong className='text-slate-800 dark:text-slate-200'>{item.text}</strong>
                    {item.desc}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* APRÈS */}
          <div className='bg-gradient-to-br from-blue-600 to-indigo-600 rounded-3xl p-8 text-white relative overflow-hidden shadow-2xl shadow-blue-200 dark:shadow-indigo-950'>
            <div className='absolute top-4 right-4 bg-white text-blue-600 px-4 py-1 rounded-full text-xs font-bold'>
              AVEC BOULESCONNECT
            </div>
            <h3 className='text-2xl font-bold mb-6 mt-8'>La simplicité digitale</h3>
            <ul className='space-y-4'>
              {APRES.map(item => (
                <li key={item.text} className='flex items-start gap-3'>
                  <CheckCircle className='w-5 h-5 text-emerald-300 mt-1 flex-shrink-0' />
                  <span>
                    <strong>{item.text}</strong>
                    {item.desc}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
